import React from 'react';
import './Dumbledore.css'
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createHistoryItem } from '../../actions/history-actions';
import { defaultTemplate, HistoryItem } from '../../utils/templateHistory';
import {
  UI_HIDE_DUMBLEDORE,
} from '../../constants/action-types';

import NumberFormat from 'react-number-format';

import * as FontAwesome from 'react-icons/lib/fa'

export class Dumbledore extends React.Component {
  constructor(props) {
    super(props);
    this.handleCreateHistory = this.handleCreateHistory.bind(this);
    this.handleOwns = this.handleOwns.bind(this);

    this.next = this.next.bind(this);

    this.renderSelection = this.renderSelection.bind(this);
    this.renderHouse = this.renderHouse.bind(this);
    this.renderCar = this.renderCar.bind(this);
    this.renderOwnCompany = this.renderOwnCompany.bind(this);
    this.renderShares = this.renderShares.bind(this);
    this.renderFinished = this.renderFinished.bind(this);

    this.nextSelection = this.nextSelection.bind(this);
    this.nextHouse = this.nextHouse.bind(this);
    this.nextCar = this.nextCar.bind(this);
    this.nextOwnCompany = this.nextOwnCompany.bind(this);
    this.nextShares = this.nextShares.bind(this);
    this.nextFinished = this.nextFinished.bind(this);

    this.handleNextStep = this.handleNextStep.bind(this)
    this.handlePrevStep = this.handlePrevStep.bind(this)

    const today = new Date();

    this.state = {
      stepsIndex: 0,
      steps: ['selection', 'house', 'car', 'ownCompany', 'shares', 'finished'],
      owns: {
        house: false,
        car: false,
        ownCompany: false,
        shares: false,
        finished: true,
      },
      houseBalance: 0,
      mortgageBalance: 0,

      carBalance: 0,
      carLoanBalance: 0,

      ownCompanyBalance: 0,

      sharesName: '',
      sharesBalance: 0,

      newHistoryItem: new HistoryItem(today),
    };
  }

  handleNextStep () {
    this.setState({ stepsIndex: this.state.stepsIndex + 1 })
  }
  handlePrevStep () {
    this.setState({ stepsIndex: this.state.stepsIndex - 1 })
  }

  handleCreateHistory() {
    const { dispatch } = this.props;
    dispatch(createHistoryItem(defaultTemplate.serialize()));
  }

  handleOwns(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    const newState = Object.assign({}, this.state);
    newState.owns[name] = value;

    this.setState(newState);
  }

  next() {
    const newState = Object.assign({}, this.state);

    let selected;
    switch (this.state.steps[0]) {
      case 'selection': selected = this.nextSelection; break;
      case 'house': selected = this.nextHouse; break;
      case 'car': selected = this.nextCar; break;
      case 'ownCompany': selected = this.nextOwnCompany; break;
      case 'shares': selected = this.nextShares; break;
      case 'finished': selected = this.nextFinished; break;
    }
    console.log("next()", this.state.steps[0], selected);

    newState.steps.shift();

    this.setState(newState);

    if(selected) {
      selected()
    }
  }

  nextSelection() {
    const newState = Object.assign({}, this.state);
    newState.steps = newState.steps.filter((stepName) => newState.owns[stepName]);
    this.setState(newState);
  }

  nextHouse() {
    const newState = Object.assign({}, this.state);

    newState.newHistoryItem.assetGroup('Investments')
      .addGenericAccount('My House', newState.houseBalance);

    newState.newHistoryItem.liabilitiesGroup('Mortgages')
      .addGenericAccount('My Mortgage', newState.mortgageBalance)

    this.setState(newState);
  }

  nextCar() {
    const newState = Object.assign({}, this.state);

    newState.newHistoryItem.assetGroup('Other')
      .addCar('My Car', newState.carBalance, 500, newState.carBalance / (12 * 5));

    if (newState.carLoanBalance != 0) {
      newState.newHistoryItem.liabilitiesGroup('Other')
        .addGenericAccount('My Car Loan', newState.carLoanBalance)
    }

    this.setState(newState);
  }

  nextOwnCompany() {
    const newState = Object.assign({}, this.state);
    newState.steps.unshift();
    console.log(newState.ownCompanyBalance)
    if (newState.ownCompanyBalance !== 0) {
      newState.newHistoryItem.assetGroup('Investments')
        .addGenericAccount('My Company', newState.ownCompanyBalance);
    }

    this.setState(newState);
  }

  nextShares() {
    if (!this.state.owns.shares) { return; }
    const newState = Object.assign({}, this.state);
    newState.steps.unshift();

    if (newState.sharesBalance !== 0) {
      newState.newHistoryItem.assetGroup('Investments')
        .addGenericAccount(newState.sharesName, newState.sharesBalance);
    }

    this.setState(newState);
  }

  nextFinished() {
    const { dispatch } = this.props;
    dispatch(createHistoryItem(this.state.newHistoryItem.serialize()));
    dispatch({ type: UI_HIDE_DUMBLEDORE });
  }

  renderSelection() {
    return (
      <div>
        <h2>What assets do you own?</h2>

        <p className="alert alert-info">
          <FontAwesome.FaInfoCircle className="icon icon--info" />
          Adding all your different assets will help us put together your first months
          breakdown of all your assets to calculate your total net worth.
          Select the assets you have below.
        </p>
        <ul className="selection-list">
          <li className="selection-list__item">
            <FontAwesome.FaHome />
            <h2>House</h2>
            <input type="checkbox" name="house" checked={this.state.owns.house} onChange={this.handleOwns} />
          </li>
          <li className="selection-list__item">
            <FontAwesome.FaCab />
            <h2>Car</h2>
            <input type="checkbox" name="car" checked={this.state.owns.car} onChange={this.handleOwns} />
          </li>
          <li className="selection-list__item">

          <FontAwesome.FaBuildingO />
            <h2>Own Company</h2>

            <input type="checkbox" name="ownCompany" checked={this.state.owns.ownCompany} onChange={this.handleOwns} />
          </li>
          <li className="selection-list__item">
          <FontAwesome.FaLineChart />
            <h2>Shares</h2>
            <input type="checkbox" name="shares" checked={this.state.owns.shares} onChange={this.handleOwns} />
          </li>
        </ul>
      </div>
    );
  }

  renderHouse() {
    return (
      <div>
        <h2>How much is your house worth?</h2>
        <p className="alert alert-info">
          <FontAwesome.FaInfoCircle className="icon icon--info" />
          This could at the time you bought the house, or the most recent time
          that you got it valued. If you get it valued again, you can simply
          add a new month and see the increase of your asset over time.
        </p>

        <NumberFormat
          className="form-control"
          value={this.state.houseBalance}
          thousandSeparator={true}
          prefix={'£'}
          onValueChange={values => {
            const {formattedValue, value} = values;
            this.setState({ houseBalance: value })
          }}
        />

        <h2>What is your morgage debt?</h2>
        <p className="alert alert-info">
          <FontAwesome.FaInfoCircle className="icon icon--info" />
          How much morgage did you take out on your new house? We will calculate
          your total worth from your house asset and your morgage debt.
          For example you might have bought a house for <strong className="text-success">£100,000</strong> and got a mortgage
          for <strong className="text-danger">£80,000</strong>. So your total net worth would be <strong className="text-success">£20,000</strong>.
        </p>

        <NumberFormat
          className="form-control"
          value={this.state.mortgageBalance}
          thousandSeparator={true}
          prefix={'£'}
          onValueChange={values => {
            const {formattedValue, value} = values;
            this.setState({ mortgageBalance: value })
          }}
        />
      </div>
    );
  }

  renderCar() {
    return (
      <div>
        <h2>How much is your car?</h2>

        <NumberFormat
          className="form-control"
          value={this.state.carBalance}
          thousandSeparator={true}
          prefix={'£'}
          onValueChange={values => {
            const {formattedValue, value} = values;
            this.setState({ carBalance: value })
          }}
        />

        <h2>How much is the loan on the car?</h2>


        <NumberFormat
          className="form-control"
          value={this.state.carLoanBalance}
          thousandSeparator={true}
          prefix={'£'}
          onValueChange={values => {
            const {formattedValue, value} = values;
            this.setState({ carLoanBalance: value })
          }}
        />

      </div>
    )
  }

  renderOwnCompany() {
    return (
      <div>
        <h2>What are the value of your shares?</h2>

        <p className="alert alert-info">
          <FontAwesome.FaInfoCircle className="icon icon--info" />
          To calculate the value of your shares you need to know the current value of your company.
          e.g. if you own 50% of your company and it's currently valued at
          £10,000 you would have £5,000 worth of shares.
        </p>

        <NumberFormat
          className="form-control"
          value={this.state.ownCompanyBalance}
          thousandSeparator={true}
          prefix={'£'}
          onValueChange={values => {
            const {formattedValue, value} = values;
            this.setState({ ownCompanyBalance: value })
          }}
        />

      </div>
    )
  }

  renderShares() {
    return (
      <div>
        <h2>What is the name of the company?</h2>

        <input
          type="text"
          className="form-control"
          value={this.state.sharesName}
          onChange={event => this.setState({ sharesName: event.target.value })}
          name="sharesName"
          placeholder="e.g. Oxford Biomedica (OXB)"
        />

        <h2>What are the value of your shares?</h2>

        <NumberFormat
          className="form-control"
          value={this.state.sharesBalance}
          thousandSeparator={true}
          prefix={'£'}
          onValueChange={values => {
            const {formattedValue, value} = values;
            this.setState({ sharesBalance: value })
          }}
        />
      </div>
    )
  }

  renderFinished() {
    return (
      <div>
        <h2>Great!</h2>
        <h3>We can now get you started tracking your monthly net worth</h3>
      </div>
    )
  }


  renderSection (stepIndex) {
    switch (this.state.steps[0]) {
      case 'selection': return this.renderSelection(); break;
      case 'house': return this.renderHouse(); break;
      case 'car': return this.renderCar(); break;
      case 'ownCompany': return this.renderOwnCompany(); break;
      case 'shares': return this.renderShares(); break;
      case 'finished': return this.renderFinished(); break;
    }
  }

  render(props) {

    const NextButton = () => {
      if (this.state.steps.length > 1) {
        return <button className="btn btn-success" onClick={this.next}>Next Step</button>;
      }
      return <button className="btn btn-success" onClick={this.next}>Continue</button>;
    }

    return (
      <div className="dumbledore">
        <div className="container">
          <div className="dumbledore__inner">
            {this.renderSection(this.state.stepsIndex)}
          </div>

          { this.state.steps.length !== 1 && (
            <button className="btn btn-light" onClick={this.handleCreateHistory}>Skip Setup</button>
          )}
          <NextButton />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  history: state.history.history,
  currentHistoryIndex: state.history.currentHistoryIndex,
  isLatestOne: state.history.history.length - 1 === state.history.currentHistoryIndex,
  isFirstRecordedMonth: state.history.currentHistoryIndex === 0,
});

export default connect(mapStateToProps)(Dumbledore);



// WEBPACK FOOTER //
// ./src/components/Dumbledore/Dumbledore.js